module.exports = "<script type=\"text/html\" id=\"propertyeditor-number\">\n  <input class=\"form-control svd_editor_control\" type=\"number\" data-bind=\"value: koValue, disable: readOnly, attr: {max: koMaxValue, min: koMinValue}\" style=\"width:100%\" />\n</script>\n";


//////////////////
// WEBPACK FOOTER
// ./src/templates/propertyEditors/propertyeditor-number.html
// module id = 126
// module chunks = 0